import type { JSX } from 'react'

import { PartnerProgramCoverDesktopSC } from './PartnerProgramCover.styled'

export const PartnerProgramCoverDesktop = (): JSX.Element => (
  <PartnerProgramCoverDesktopSC
    viewBox='0 0 1920 1080'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    preserveAspectRatio='none'
  >
    <g clipPath='url(#clip0_743_35742)'>
      <rect width='1920' height='1080' fill='#0D0D0D' />
      <path
        d='M1106.52 1559.6C783.069 1340.49 147.374 1002.11 216.688 162.926C268.599 -465.576 1225.18 -869.648 1171.52 -346.468C1117.86 176.713 540.534 -246.857 1886.49 -452.552C3232.45 -658.247 2304.91 1107.97 1562.62 1116.91C820.332 1125.85 1383.76 -153.033 2559.8 -260.352M654.556 -194.32C977.851 -199.943 1490.34 67.97 953.955 1184.6'
        stroke='url(#paint0_linear_743_35742)'
        strokeWidth='160'
      />
      <path
        d='M2712.68 -178.833C2851.76 282.867 2991.25 1277.04 2436.61 1560.11C1743.32 1913.96 1270.04 1280.04 1728.87 820.869C2187.69 361.694 2532.53 1958.26 1083.53 1107.01C-365.464 255.757 1213.45 -679.667 1931.19 -110.148C2648.92 459.371 1113.45 1245.16 -96.2285 432.047'
        stroke='url(#paint1_linear_743_35742)'
        strokeWidth='173.763'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_743_35742'
        x1='1454.65'
        y1='-260.352'
        x2='1454.65'
        y2='1559.6'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#303030' />
        <stop offset='1' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_743_35742'
        x1='961.988'
        y1='1292.72'
        x2='2379.33'
        y2='-449.952'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#303030' />
        <stop offset='1' />
      </linearGradient>
      <clipPath id='clip0_743_35742'>
        <rect width='1920' height='1080' fill='white' />
      </clipPath>
    </defs>
  </PartnerProgramCoverDesktopSC>
)
